import {Hydra} from '../generic/hydra';

import {MotCleTranslation as MotCleTranslationBaseInterface} from '../../interface/api/MotCleTranslation';

export type MotCleTranslationInterface = MotCleTranslationBaseInterface;

export class MotCleTranslation extends Hydra implements MotCleTranslationInterface {

    id?: number | null;

    /* ex: en, fr, etc.
     */
    locale?: string | null;

    label?: string | null;


    constructor(options: MotCleTranslationInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
